import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the table view for approval quota retraction.
 * @extends JetView
 */
export default class tableApprovalQuotaRetractionView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance

        // Sample data for the datatable
        const data = [
            {
                Id: '01',
                Title: 'Prueba 1',
                Description: 'Descripción de la petición numero 1',
                Department: '0',
                State: '0',
                UserCreated: '001',
                DateCreation: '2019-02-13 11:32:20',
            },
            {
                Id: '02',
                Title: 'Prueba 2',
                Description: 'Descripción de la petición numero 2',
                Department: '1',
                State: '1',
                UserCreated: '002',
                DateCreation: '2019-02-12 10:32:20',
            },
        ];

        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader
                    cols: [
                        {
                            view: 'datatable', // DataTable component
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            id: 'datatable', // ID for the datatable
                            select: true, // Enable row selection
                            scrollY: screen.width < 820 ? false : true, // Conditional vertical scrolling
                            height: screen.width < 820 ? 405 : 0, // Conditional height based on screen width
                            columns: [
                                {
                                    id: 'ActionTittle', // Column ID for action buttons
                                    header: '', // Column header
                                    width: 65, // Column width
                                    height: 25, // Column height
                                    tooltip: _('Acción'), // Tooltip for the column
                                    template: function (obj) {
                                        // Template function for rendering action buttons
                                        if (obj.StateId !== 'P') {
                                            return ''; // No buttons if state is not 'P'
                                        } else {
                                            if (devConfig.getPermAction('approvalQuotaRetraction', 'Approve')) {
                                                // Render approve and refuse buttons if permission is granted
                                                return "<span class='webix_icon wxi-close approve prm-approvalQuotaRetraction'></span><span class='webix_icon wxi-close torefuse prm-approvalQuotaRetraction'></span>";
                                            } else {
                                                return ''; // No buttons if permission is not granted
                                            }
                                        }
                                    },
                                },
                                {
                                    id: 'Id', // Column ID for Id
                                    header: 'Id', // Column header
                                    width: 90, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Date', // Column ID for creation date
                                    header: _('Fecha Creación'), // Column header with localization
                                    fillspace: 0, // Fill space option
                                    minWidth: 0, // Minimum width
                                    width: 200, // Column width
                                    sort: 'text', // Sorting type
                                    format: dateFormat, // Date formatting
                                },
                                {
                                    id: 'UserCreate', // Column ID for user who created the entry
                                    header: _('Usuario Creó'), // Column header with localization
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Type', // Column ID for balance type
                                    header: _('Tipo de Saldo'), // Column header with localization
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        {
                                            id: '0',
                                            value: _('Saldo de Recargas'), // Localized value
                                        },
                                        { id: '0', value: _('Saldo de Juego') }, // Localized value
                                    ],
                                    width: 200, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'Amount', // Column ID for amount
                                    header: _('Valor'), // Column header with localization
                                    width: 150, // Column width
                                    sort: 'int', // Sorting type
                                    format: webix.Number.numToStr({
                                        // Formatting for number
                                        groupDelimiter: ',',
                                        groupSize: 3,
                                        decimalDelimiter: '.',
                                        decimalSize: 2,
                                    }),
                                },
                                {
                                    id: 'StateId', // Column ID for state
                                    header: _('Estado'), // Column header with localization
                                    editor: 'combo', // Editor type
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Aprobada') }, // Localized value
                                        { id: 'R', value: _('Rechazada') }, // Localized value
                                        { id: 'P', value: _('Pendiente') }, // Localized value
                                    ],
                                    width: 110, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                // Event handlers for click events
                                torefuse: function (euv, id) {
                                    // Handler for refuse action
                                    var vvthis = this; // Reference to the current instance
                                    webix.confirm({
                                        // Confirmation dialog
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea Rechazar la Retracción de Saldo?'),
                                        ok: _('Rechazar Retracción de Saldo'), // OK button text
                                        cancel: _('Salir'), // Cancel button text
                                        callback: function (action) {
                                            // Callback for confirmation
                                            if (action === true) {
                                                var item = vvthis.getItem(id); // Get the item from the datatable
                                                webix
                                                    .ajax() // AJAX request to reject the retraction
                                                    .headers({
                                                        'Content-type': 'application/json',
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Agent/ApprovalQuotaRetraction',
                                                        '{"Id":"' + item.Id + '", "State":"R"}',
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message(
                                                                    _('Error! '), // Error message
                                                                );
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                var json = JSON.parse(
                                                                    text, // Parse the response
                                                                );
                                                                if (json.HasError) {
                                                                    webix.message({
                                                                        title: _('¡Error!'),
                                                                        type: 'alert-error',
                                                                        text: _(
                                                                            'Ocurrio un error, comuniquese con soporte',
                                                                        ),
                                                                    }); // Error handling
                                                                } else {
                                                                    webix.message({
                                                                        text: _('Estado de Retracción actualizado'),
                                                                        title: _('¡Exito!'),
                                                                        type: 'alert-warning',
                                                                    }); // Success message
                                                                    item.StateId = 'R'; // Update state
                                                                    $$('datatable').refresh(); // Refresh the datatable
                                                                }
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                },
                                approve: function (euv, id) {
                                    // Handler for approve action
                                    var vvthis = this; // Reference to the current instance
                                    webix.confirm({
                                        // Confirmation dialog
                                        type: 'confirm-warning',
                                        text: _('Advertencia!') + '<br/>' + _('Desea Aprobar el Retracción de Saldo?'),
                                        ok: _('Aprobar Retracción de Saldo'), // OK button text
                                        cancel: _('Salir'), // Cancel button text
                                        callback: function (action) {
                                            // Callback for confirmation
                                            if (action === true) {
                                                var item = vvthis.getItem(id); // Get the item from the datatable
                                                webix
                                                    .ajax() // AJAX request to approve the retraction
                                                    .headers({
                                                        'Content-type': 'application/json',
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Agent/ApprovalQuotaRetraction',
                                                        '{"Id":"' + item.Id + '", "State":"A"}',
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message(
                                                                    _('Error! '), // Error message
                                                                );
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                console.log(
                                                                    text, // Log the response
                                                                );
                                                                var json = JSON.parse(
                                                                    text, // Parse the response
                                                                );
                                                                if (json.HasError) {
                                                                    webix.message({
                                                                        title: _('¡Error!'),
                                                                        type: 'alert-error',
                                                                        text: _(
                                                                            'Ocurrio un error, comuniquese con soporte',
                                                                        ),
                                                                    }); // Error handling
                                                                } else {
                                                                    webix.message({
                                                                        text: _('Estado de Retracción actualizado'),
                                                                        title: _('¡Exito!'),
                                                                        type: 'alert-warning',
                                                                    }); // Success message
                                                                    item.StateId = 'A'; // Update state
                                                                    $$('datatable').refresh(); // Refresh the datatable
                                                                }
                                                            },
                                                        },
                                                    );
                                            }
                                        },
                                    });
                                },
                            },
                            on: {
                                onItemDblClick: function () {
                                    // Event handler for double-click
                                    $$('editwin').show(); // Show edit window
                                },
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // Pager ID
                            url: devConfig.geturlApi() + 'null/Report/GetQuotaRetraction', // Data source URL
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        grid = $$('datatable'); // Reference to the datatable
        var url = grid.data.url; // Data source URL
        var vthis = this; // Reference to the current instance
        var filter = ''; // Filter string

        // Event listener for filtering requests
        this.on(this.app, 'requests:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date);
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to filter
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to filter
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Parse start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add start date to filter
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Parse end date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add end date to filter
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear the datatable
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load filtered data
            filter = string1; // Update filter string
        });

        // Event listener for sorting
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        // Create edit window UI
        var ttt = webix.ui({
            view: 'window',
            move: true, // Allow window to be moved
            id: 'editwin', // ID for the edit window
            head: {
                view: 'toolbar', // Toolbar for the window header
                cols: [
                    { view: 'label', label: _('Editar'), align: 'center' }, // Label for editing
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide the window on close
                        },
                    },
                ],
            },
            modal: true, // Modal window
            position: 'center', // Center position
            body: {
                view: 'form', // Form inside the window
                id: 'editform', // ID for the edit form
                elements: [
                    {
                        view: 'text',
                        label: _('UserName'), // Label for username
                        name: 'UserName', // Name for the input
                        readonly: true, // Make the input read-only
                    },
                    {
                        view: 'imageLabel', // Custom image label component
                        name: _('Imagen'), // Name for the image
                        width: 500, // Width of the image
                        height: 500, // Height of the image
                    },
                    {
                        cols: [
                            {
                                view: 'button',
                                value: _('Listo'), // Button text
                                click: function () {
                                    this.getTopParentView().hide(); // Hide the window on button click
                                },
                            },
                        ],
                    },
                ],
            },
        });
        $$('editform').bind($$('datatable')); // Bind the edit form to the datatable
    }
}

// Custom UI component for displaying an image
webix.protoUI(
    {
        name: 'imageLabel', // Component name
        setValue: function (value) {
            // Function to set the image source
            this.setHTML(
                "<img style='width:100%;height: 100%;' src='" + value + "'></img>", // Set the HTML for the image
            );
        },
    },
    webix.ui.label, // Extend the webix label component
);

// FILE DOCUMENTED
